module.exports = __webpack_public_path__ + "img/watch-map.83015295.svg";